{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -28.472391045486518,
              65.44987685032723
            ],
            [
              -10.775781348430911,
              50.54302236423021
            ],
            [
              -3.4509110754219137,
              49.35373359243221
            ],
            [
              1.87841135532517,
              50.996031288065524
            ],
            [
              8.7788687299022,
              57.94471437251636
            ],
            [
              14.261392233367758,
              54.834881844831926
            ],
            [
              20.202179570207903,
              57.82081183445021
            ],
            [
              19.851316110429792,
              61.58892304729147
            ],
            [
              20.255444348898948,
              63.1066361345307
            ],
            [
              24.099772881942926,
              65.49509661391758
            ],
            [
              22.583112804656793,
              71.32669015968094
            ],
            [
              -5.634464819220142,
              70.70430303266284
            ],
            [
              -28.472391045486518,
              65.44987685032723
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}